<div>
	<button
		(click)="openFilterModal()"
		[disabled]="false"
		data-bs-toggle="modal"
    data-bs-target="#sidefilter"
		type="button"
		class="btn-switch"
	>
		<i class="fal fa-filter pr-2"></i>
		FILTROS
	</button>
</div>

<div
	class="modal right fade"
	id="sidefilter"
	tabindex="-1"
	role="dialog"
	aria-labelledby="exampleModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<div class="row d-flex justify-content-between">
					<div class="col-auto p-0">
						<button class="btn btn-sm btn-apply" (click)="doApply()" data-bs-dismiss="modal">
							<i class="fal fa-check pr-2 align-middle"></i><span class="align-middle">APLICAR</span>
						</button>
					</div>
					<div class="col-auto p-0">
						<button class="btn btn-sm btn-cancel" data-bs-dismiss="modal">CANCELAR</button>
					</div>
				</div>
			</div>

			<div class="modal-body">
				<form *ngIf="filterForm" role="form" [formGroup]="filterForm">
					<!-- PROFILES -->
					<ng-container *ngIf="filterConfiguration.showProfile">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Perfils</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('profiles')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="roles">
										<div class="col-12" *ngFor="let item of roles">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('roles', item.value)"
												(change)="onChangeItem('roles', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="roles.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- PROFILES END -->

          <!-- PROOFS -->
					<ng-container *ngIf="filterConfiguration.showProofs">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Atestados</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('proofTypes')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="proofTypes">
										<div class="col-12" *ngFor="let item of proofTypes">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('proofTypes', item.value)"
												(change)="onChangeItem('proofTypes', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="proofTypes.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- PROOFS END -->

					<!-- STATUS -->
					<ng-container *ngIf="filterConfiguration.showStatus">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Status</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('status')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="status">
										<div class="col-12" *ngFor="let item of status">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('status', item.value)"
												(change)="onChangeItem('status', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="status.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- STATUS END -->

          <!-- STATUS DEFAULT -->
          <ng-container *ngIf="filterConfiguration.showStatusDefault">
            <div class="row d-flex justify-content-between header-filter-group">
              <div class="col-auto">
                <h3 class="filter-group">Status</h3>
              </div>
              <div class="col-auto pr-4">
                <a (click)="clearAllItem('statusDefault')" role="button">
                  <i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="box-filter">
                  <div class="row list-filter" *ngIf="statusDefault">
                    <div class="col-12" *ngFor="let item of statusDefault">
                      <mat-checkbox
                        class="checklist-leaf-node"
                        [checked]="itemChecked('statusDefault', item.value)"
                        (change)="onChangeItem('statusDefault', $event)"
                        [value]="item.value"
                      >
                        {{ item.label }}
                      </mat-checkbox>
                    </div>
                    <div class="col-12 text-center" *ngIf="statusDefault.length === 0">Not found</div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- STATUS DEFAULT END -->

					<!-- VACINNES -->
					<ng-container *ngIf="filterConfiguration.showVaccines">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Vacinas</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('vaccines')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="vacinnes">
										<div class="col-12" *ngFor="let item of vacinnes">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('vaccines', item.value)"
												(change)="onChangeItem('vaccines', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="vacinnes.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- VACINNES END -->

					<!-- GENDER -->
					<ng-container *ngIf="filterConfiguration.showGenres">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Gênero</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('genres')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="genres">
										<div class="col-12" *ngFor="let item of genres">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('genres', item.value)"
												(change)="onChangeItem('genres', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="genres.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- GENDER END -->

					<!-- ACCOUNT -->
					<ng-container *ngIf="filterConfiguration.showAccountType">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Conta</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('accountTypes')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="accountTypes">
										<div class="col-12" *ngFor="let item of accountTypes">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('accountTypes', item.value)"
												(change)="onChangeItem('accountTypes', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="accountTypes.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- ACCOUNT END -->

					<!-- AGES -->
					<ng-container *ngIf="filterConfiguration.showAges">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Faixa Etária</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('ages')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter" *ngIf="ages">
										<div class="col-12" *ngFor="let item of ages">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('ages', item.value)"
												(change)="onChangeItem('ages', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="proofTypes.length === 0">Not found</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- AGES END -->

					<!-- DEPARTAMENTS -->
					<ng-container *ngIf="filterConfiguration.showDepartments">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Departamentos</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('companyDepartments')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<p class="filter-hint" *ngIf="filterConfiguration.showSampleSizeHint && (filterConfiguration.showGenres || filterConfiguration.showAges)">
							Cruzar com Gênero/Faixa etária pode reduzir a amostra — resultado some abaixo de 5 pessoas.
						</p>
						<div class="row">
								<div class="col-12">
									<div class="box-filter">
										<div class="filter-search" *ngIf="companyDepartments.length > 5">
											<button
												type="button"
												class="filter-search-clear"
												(click)="clearSearch('companyDepartments')"
												[disabled]="!departmentSearchTerm"
												aria-label="Limpar busca de departamentos"
											>
												<i class="fal fa-trash-alt"></i>
											</button>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar departamento"
											[value]="departmentSearchTerm"
											(input)="onSearchItems('companyDepartments', $event)"
										/>
									</div>
									<div class="row list-filter" *ngIf="filteredCompanyDepartments">
										<div class="col-12" *ngFor="let item of filteredCompanyDepartments">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('companyDepartments', item.value)"
												(change)="onChangeItem('companyDepartments', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="filteredCompanyDepartments.length === 0">Nenhum departamento encontrado</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- DEPARTAMENTS END -->
					<!-- RISKS -->
					<ng-container *ngIf="filterConfiguration.riskOptions?.length">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Risco</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('riskLevels')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter">
										<div class="col-12" *ngFor="let item of filterConfiguration.riskOptions">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('riskLevels', item.value)"
												(change)="onChangeItem('riskLevels', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- RISKS END -->
					<!-- AREAS -->
					<ng-container *ngIf="filterConfiguration.areaOptions?.length">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Área</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('areas')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="box-filter">
									<div class="row list-filter">
										<div class="col-12" *ngFor="let item of filterConfiguration.areaOptions">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('areas', item.value)"
												(change)="onChangeItem('areas', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- AREAS END -->

					<!-- ROLES -->
					<ng-container *ngIf="filterConfiguration.showRoles">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Cargos</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('companyRoles')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
								<div class="col-12">
									<div class="box-filter">
										<div class="filter-search" *ngIf="companyRoles.length > 5">
											<button
												type="button"
												class="filter-search-clear"
												(click)="clearSearch('companyRoles')"
												[disabled]="!roleSearchTerm"
												aria-label="Limpar busca de cargos"
											>
												<i class="fal fa-trash-alt"></i>
											</button>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar cargo"
											[value]="roleSearchTerm"
											(input)="onSearchItems('companyRoles', $event)"
										/>
									</div>
									<div class="row list-filter" *ngIf="filteredCompanyRoles">
										<div class="col-12" *ngFor="let item of filteredCompanyRoles">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('companyRoles', item.value)"
												(change)="onChangeItem('companyRoles', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="filteredCompanyRoles.length === 0">Nenhum cargo encontrado</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- ROLES END -->

					<!-- LOCALITIES -->
					<ng-container *ngIf="filterConfiguration.showLocalities">
						<div class="row d-flex justify-content-between header-filter-group">
							<div class="col-auto">
								<h3 class="filter-group">Localidades</h3>
							</div>
							<div class="col-auto pr-4">
								<a (click)="clearAllItem('companyLocalities')" role="button">
									<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
								</a>
							</div>
						</div>
						<div class="row">
								<div class="col-12">
									<div class="box-filter">
										<div class="filter-search" *ngIf="companyLocalities.length > 5">
											<button
												type="button"
												class="filter-search-clear"
												(click)="clearSearch('companyLocalities')"
												[disabled]="!localitySearchTerm"
												aria-label="Limpar busca de localidades"
											>
												<i class="fal fa-trash-alt"></i>
											</button>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar localidade"
											[value]="localitySearchTerm"
											(input)="onSearchItems('companyLocalities', $event)"
										/>
									</div>
									<div class="row list-filter" *ngIf="filteredCompanyLocalities">
										<div class="col-12" *ngFor="let item of filteredCompanyLocalities">
											<mat-checkbox
												class="checklist-leaf-node"
												[checked]="itemChecked('companyLocalities', item.value)"
												(change)="onChangeItem('companyLocalities', $event)"
												[value]="item.value"
											>
												{{ item.label }}
											</mat-checkbox>
										</div>
										<div class="col-12 text-center" *ngIf="filteredCompanyLocalities.length === 0">Nenhuma localidade encontrada</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- LOCATIONS END -->

          <!-- HEALTHPLANS -->
          <ng-container *ngIf="filterConfiguration.showHealthPlans">
            <div class="row d-flex justify-content-between header-filter-group">
              <div class="col-auto">
                <h3 class="filter-group">Operadora de Saúde</h3>
              </div>
              <div class="col-auto pr-4">
                <a (click)="clearAllItem('companyHealthPlans')" role="button">
                  <i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="box-filter">
									<div class="filter-search" *ngIf="companyHealthPlans.length > 5">
										<button
											type="button"
											class="filter-search-clear"
											(click)="clearSearch('companyHealthPlans')"
											[disabled]="!healthPlanSearchTerm"
											aria-label="Limpar busca de operadoras de saude"
										>
											<i class="fal fa-trash-alt"></i>
										</button>
										<input
											type="text"
											class="form-control"
											placeholder="Buscar operadora de saúde"
											[value]="healthPlanSearchTerm"
											(input)="onSearchItems('companyHealthPlans', $event)"
										/>
									</div>
                  <div class="row list-filter" *ngIf="filteredCompanyHealthPlans">
                    <div class="col-12" *ngFor="let item of filteredCompanyHealthPlans">
                      <mat-checkbox
                        class="checklist-leaf-node"
                        [checked]="itemChecked('companyHealthPlans', item.value)"
                        (change)="onChangeItem('companyHealthPlans', $event)"
                        [value]="item.value"
                      >
                        {{ item.label }}
                      </mat-checkbox>
                    </div>
                    <div class="col-12 text-center" *ngIf="filteredCompanyHealthPlans.length === 0">Nenhuma operadora encontrada</div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- HEALTHPLANS END -->
				</form>
			</div>
		</div>
	</div>
</div>
